import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { List, ListItem } from '@jsluna/list';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var baseClassName = 'ln-c-breadcrumbs';

var BreadcrumbsWrapper = function BreadcrumbsWrapper(_ref) {
  var element = _ref.element,
      children = _ref.children,
      className = _ref.className,
      narrow = _ref.narrow,
      light = _ref.light,
      backToParent = _ref.backToParent,
      color = _ref.color,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "children", "className", "narrow", "light", "backToParent", "color"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    "aria-label": "Breadcrumb"
  }), /*#__PURE__*/React.createElement(List, {
    className: classnames("" + baseClassName, backToParent && baseClassName + "--back-to-parent", narrow && baseClassName + "--narrow", light && baseClassName + "--light", color && baseClassName + "--" + color, className),
    type: "inline",
    ordered: true
  }, children));
};

BreadcrumbsWrapper.displayName = 'BreadcrumbsWrapper';
BreadcrumbsWrapper.propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,

  /** Show only the latest parent crumb on smaller screens */
  narrow: PropTypes.bool,

  /** @deprecated Use the light theme color for nested links */
  light: PropTypes.bool,

  /** Show only the latest parent crumb */
  backToParent: PropTypes.bool,

  /** Colour theme to be used */
  color: PropTypes.string
};
BreadcrumbsWrapper.defaultProps = {
  element: 'nav',
  className: undefined,
  narrow: false,
  light: false,
  backToParent: false,
  color: undefined
};

var BreadcrumbsItem = function BreadcrumbsItem(_ref) {
  var children = _ref.children,
      active = _ref.active,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "active", "className"]);

  var linkProps = {
    className: 'ln-c-breadcrumbs__link',
    'aria-current': active ? 'page' : undefined
  };
  return /*#__PURE__*/React.createElement(ListItem, _extends({}, rest, {
    type: "inline",
    className: classnames('ln-c-breadcrumbs__item', active && 'ln-c-breadcrumbs__item--active', className)
  }), React.Children.count(children) === 1 && React.isValidElement(children) ? React.cloneElement(React.Children.only(children), linkProps) : /*#__PURE__*/React.createElement("span", linkProps, children));
};

BreadcrumbsItem.displayName = 'BreadcrumbsItem';
BreadcrumbsItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  active: PropTypes.bool
};
BreadcrumbsItem.defaultProps = {
  active: false,
  className: undefined
};

export { BreadcrumbsWrapper, BreadcrumbsItem };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/breadcrumbs/dist/index.js
// module id = 510
// module chunks = 0